module.exports = __webpack_public_path__ + "static/media/Troll-Unselected.b0bdf637.png";